/* tslint:disable */
/* eslint-disable */
/**
 * Dialpad Contact API
 * API to fetch call center groups with specific filters.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../../common/runtime';
import type { UserCompany } from './UserCompany';
import {
  UserCompanyFromJSON,
  UserCompanyFromJSONTyped,
  UserCompanyToJSON,
} from './UserCompany';
import type { GroupDetails } from './GroupDetails';
import {
  GroupDetailsFromJSON,
  GroupDetailsFromJSONTyped,
  GroupDetailsToJSON,
} from './GroupDetails';
import type { OperatorGroup } from './OperatorGroup';
import {
  OperatorGroupFromJSON,
  OperatorGroupFromJSONTyped,
  OperatorGroupToJSON,
} from './OperatorGroup';

/**
 *
 * @export
 * @interface User
 */
export interface User {
  /**
   *
   * @type {string}
   * @memberof User
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof User
   */
  key?: string;
  /**
   *
   * @type {string}
   * @memberof User
   */
  shortKey?: string;
  /**
   *
   * @type {UserCompany}
   * @memberof User
   */
  company?: UserCompany;
  /**
   *
   * @type {string}
   * @memberof User
   */
  firstName?: string;
  /**
   *
   * @type {string}
   * @memberof User
   */
  lastName?: string;
  /**
   *
   * @type {string}
   * @memberof User
   */
  displayName?: string;
  /**
   *
   * @type {string}
   * @memberof User
   */
  imageUrl?: string;
  /**
   *
   * @type {boolean}
   * @memberof User
   */
  isAdmin?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof User
   */
  isSuperAdmin?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof User
   */
  isGoogleAdmin?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof User
   */
  isMicrosoftAdmin?: boolean;
  /**
   *
   * @type {string}
   * @memberof User
   */
  ivrLanguage?: string;
  /**
   *
   * @type {string}
   * @memberof User
   */
  locale?: string;
  /**
   *
   * @type {Array<OperatorGroup>}
   * @memberof User
   */
  operatorGroups?: Array<OperatorGroup>;
  /**
   *
   * @type {Array<string>}
   * @memberof User
   */
  experiments?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof User
   */
  officeKey?: string;
  /**
   *
   * @type {Array<GroupDetails>}
   * @memberof User
   */
  groupDetails?: Array<GroupDetails>;
}

/**
 * Check if a given object implements the User interface.
 */
export function instanceOfUser(value: object): value is User {
  if (!('id' in value) || value['id'] === undefined) return false;
  return true;
}

export function UserFromJSON(json: any): User {
  return UserFromJSONTyped(json, false);
}

export function UserFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): User {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    key: json['key'] == null ? undefined : json['key'],
    shortKey: json['short_key'] == null ? undefined : json['short_key'],
    company:
      json['company'] == null
        ? undefined
        : UserCompanyFromJSON(json['company']),
    firstName: json['first_name'] == null ? undefined : json['first_name'],
    lastName: json['last_name'] == null ? undefined : json['last_name'],
    displayName:
      json['display_name'] == null ? undefined : json['display_name'],
    imageUrl: json['image_url'] == null ? undefined : json['image_url'],
    isAdmin: json['is_admin'] == null ? undefined : json['is_admin'],
    isSuperAdmin:
      json['is_super_admin'] == null ? undefined : json['is_super_admin'],
    isGoogleAdmin:
      json['is_google_admin'] == null ? undefined : json['is_google_admin'],
    isMicrosoftAdmin:
      json['is_microsoft_admin'] == null
        ? undefined
        : json['is_microsoft_admin'],
    ivrLanguage:
      json['ivr_language'] == null ? undefined : json['ivr_language'],
    locale: json['locale'] == null ? undefined : json['locale'],
    operatorGroups:
      json['operator_groups'] == null
        ? undefined
        : (json['operator_groups'] as Array<any>).map(OperatorGroupFromJSON),
    experiments: json['experiments'] == null ? undefined : json['experiments'],
    officeKey: json['office_key'] == null ? undefined : json['office_key'],
    groupDetails:
      json['group_details'] == null
        ? undefined
        : (json['group_details'] as Array<any>).map(GroupDetailsFromJSON),
  };
}

export function UserToJSON(value?: User | null): any {
  if (value == null) {
    return value;
  }
  return {
    id: value['id'],
    key: value['key'],
    short_key: value['shortKey'],
    company: UserCompanyToJSON(value['company']),
    first_name: value['firstName'],
    last_name: value['lastName'],
    display_name: value['displayName'],
    image_url: value['imageUrl'],
    is_admin: value['isAdmin'],
    is_super_admin: value['isSuperAdmin'],
    is_google_admin: value['isGoogleAdmin'],
    is_microsoft_admin: value['isMicrosoftAdmin'],
    ivr_language: value['ivrLanguage'],
    locale: value['locale'],
    operator_groups:
      value['operatorGroups'] == null
        ? undefined
        : (value['operatorGroups'] as Array<any>).map(OperatorGroupToJSON),
    experiments: value['experiments'],
    office_key: value['officeKey'],
    group_details:
      value['groupDetails'] == null
        ? undefined
        : (value['groupDetails'] as Array<any>).map(GroupDetailsToJSON),
  };
}
